// extracted by mini-css-extract-plugin
module.exports = {"summary":"summary_summary__3t1ck","content":"summary_content__2HRQ4"};